import { useEffect } from 'react';
import { log } from 'log';
import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useUserSelector } from 'js/store/hooks';
import { TGetPlayerTagsResponse } from 'js/hooks/socket/types';

import * as server from '../server';
import * as actions from '../store/actions';
import { TOAST_MESSAGE_PREFS_TAG_NAME } from '../constants';

export const useGetToastTimeoutValue = () => {
    const dispatch = useDispatch();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));

    useEffect((): void => {
        (async (): Promise<void> => {
            try {
                if (!isLoggedIn) {
                    return;
                }

                const { data: { tags = [] } } =
                    await server.getPlayerTags(TOAST_MESSAGE_PREFS_TAG_NAME) as TGetPlayerTagsResponse;
                const toastTimeoutValue = Number(tags?.[0]?.value);

                toastTimeoutValue && dispatch(actions.userSetAttributesAction({ toastTimeoutValue }));
            } catch (error) {
                log('error', error);
            }
        })();
    }, [dispatch, isLoggedIn]);
};
